import { Button, Space, Typography } from 'antd';
import React from 'react';
import { settingsConfig } from '../config/settingsConfig';
import { useSettingsStore } from '../hooks/useSettingsStore';
import SettingsRow from './SettingsRow';

const { Title } = Typography;

const SettingsList: React.FC = () => {
  const { general, setGeneral, resetGeneral } = useSettingsStore();

  return (
    <div>
      {settingsConfig.map((cfg, index) => {
        if (cfg.type === 'title') {
          return (
            <Title key={`title-${index}`} level={5} style={{ marginTop: index === 0 ? 0 : 24, marginBottom: 16 }}>
              {cfg.label}
            </Title>
          );
        }

        if (!cfg.key) return null;

        return (
          <SettingsRow
            key={cfg.key}
            label={cfg.label}
            value={general[cfg.key]}
            type={cfg.type}
            options={cfg.options}
            min={cfg.min}
            max={cfg.max}
            tooltip={cfg.tooltip}
            onChange={(value) => setGeneral(cfg.key!, value)}
          />
        );
      })}
      <Space style={{ marginTop: 16, justifyContent: 'flex-end', width: '100%', display: 'flex' }}>
        <Button onClick={resetGeneral}>Reset Settings</Button>
      </Space>
    </div>
  );
};

export default SettingsList;
